module.exports = __webpack_public_path__ + "resources/img/img_dvision3.4ef82c55006e46a45566ba43514a88ee.png";